import { atom } from "@mongez/react-atom";

export type BoardOfDirectorsAtomValue = {
  boardOfDirectors: any[];
  executiveManagement: any[];
};

export const boardOfDirectorsAtom = atom<BoardOfDirectorsAtomValue>({
  key: "boardOfDirectors",
  default: {
    boardOfDirectors: [],
    executiveManagement: [],
  },
});
